module.exports = __webpack_public_path__ + "img/icon_4@2x.d6d8c263.png";